import { useSwrMutationApi } from '@hooks/useSwrApi';

/**
 * @description Props
 */
interface UseSwrCreateCompanyProps {
  locale: Locale;
  successCallback?: () => void;
}

/**
 * @description SWR: post company
 * - `locale:` *string* - The current app locale.
 * - `successCallback:` *function* - The callback to execute after the fetch.
 */
export const useSwrCreateCompany = (props: UseSwrCreateCompanyProps) => {
  // Destructure props
  const {
    locale,
    successCallback,
  } = props;


  // SWR: fetch data
  const {
    data, error, trigger, reset, isMutating,
  } = useSwrMutationApi<ApiSchema<'CompanyWrite'>, object>({
    url: '/v1/company',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) {
          void successCallback();
        }
      },
    },
  });

  // Return data
  return {
    data,
    error,
    trigger,
    reset,
    isMutating,
  };
};
